import { render, staticRenderFns } from "./Areceivable.vue?vue&type=template&id=816072ec&scoped=true&"
import script from "./Areceivable.vue?vue&type=script&lang=js&"
export * from "./Areceivable.vue?vue&type=script&lang=js&"
import style0 from "./Areceivable.vue?vue&type=style&index=0&id=816072ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816072ec",
  null
  
)

export default component.exports